// Called by : src/App.vue (router-view)

<template>
  <div class="row">
    <div id="card_connect" class="card text-center col-xs-12 col-sm-10 col-md-8 col-lg-6 m-auto mt-sm-5 p-0">
      <div class="card-body p-sm-5 p-xs-2">

        <h4 class="text-muted mb-0">{{ $t("connect.welcome") }}</h4>
        <h1 class="inf_title txt_ombre_ccc display-3 font-italic">{{ $t("connect.name") }}</h1>
        <h3 class="font-weight-normal text-muted">{{ $t("connect.slogan") }}</h3>
        <h5 class="font-weight-normal text-muted">{{ $t("connect.desc") }}</h5>

        <div class="sep my-1">&nbsp;</div>

        <div class="form_cont px-xs-0 px-sm-2">

          <div class="input-group text-left">
            <label class="input-group-prepend w-50" for="login">
              <span class="input-group-text px-xs-2 px-sm-3 w-100"><span class="oi oi-person text-muted pr-2"></span>{{ $t("connect.login") }}</span>
            </label>
            <input type="text" id="login" ref="rLgn" class="form-control" v-model="user.login" @change="initInfo">
          </div>

          <div class="input-group text-left">
            <label class="input-group-prepend w-50" for="password">
              <span class="input-group-text px-xs-2 px-sm-3 w-100"><span class="oi oi-lock-locked text-muted pr-2"></span>{{ $t("connect.password") }}</span>
            </label>
            <input type="password" id="password" ref="rPss" class="form-control" v-model="user.password" @change="initInfo">
          </div>

          <button type="submit" id="submit" ref="rSbm" class="btn_page_submit btn btn-primary btn-block btn-lg mt-2 py-3" :disabled="getDisabled()" @click="submit">
            <span class="oi oi-key mr-3" style="font-size: 1.2rem;"></span>
            {{ $t("connect.connect") }}
          </button>

        <div class="alert alert-primary" v-if="infoMsg"><img :src="constants.assets.load_000" alt="loader" width="32" height="32">&nbsp;&nbsp;{{ infoMsg }}</div>
        <div class="alert alert-warning" v-if="errorMsg">{{ errorMsg }}</div>

      </div> <!-- .form_cont -->
      </div> <!-- .card-body -->
    </div> <!-- .card -->
  </div> <!-- .row -->

</template>

<script>
import { constants } from '@/constants'
import Model from '@/model/Model'

export default {
  data () {
    return {
      user: {
        login: '',
        password: '',
        zkp: '',
        firstName: '',
        lastName: '',
        fullName: '',
      },
      model: null,
      fm: null,
      infoMsg: '',
      errorMsg: '',
    }
  },
  methods: {
    getDisabled() {
      let bOff = Boolean(!this.user.login || !this.user.password);
      f_setPageBtnOff_v(bOff);
      return bOff;
    },
    initInfo() {
      this.infoMsg = '';
    },
    submit() {
      /*
      document.getElementsByID("submit").disabled = true;
      document.getElementsByID("submit").style.display = none;
      this.$refs.rSbm.style.display = 'none';
      this.$refs.rSbm.disabled = true;
      this.$refs.rLgn.value = "";
      this.$refs.rPss.value = "";
      this.getDisabled();
      */
     
      // On vide les champs de saisie et on rend le bouton submit inactif pour éviter les soumissions multiples
      var sLogin = this.user.login;
      var sPass = this.user.password;
      this.user.login = "";
      this.user.password = "";

      // On affiche un message d'information pour indiquer que la connexion est en cours
      this.infoMsg = this.$t("connect.wait");

      // On remet les placeholders pour informer l'utilisateur que les champs sont vides et que la connexion est en cours
      this.$refs.rLgn.placeholder = sLogin;
      this.$refs.rPss.placeholder = "•".repeat(sPass.length);

      // console.log('submit',sLogin,sPass);
      // return false;

      this.model = new Model(sLogin, sPass);
      this.model.login()
      .then((loginSuccess) => {
        this.model.getUser(sLogin, sPass)
        .then((userSuccess) => {
          this.model.getParams()
          .then((paramSuccess) => {

            console.log('isNotMultiConnect',paramSuccess.isNotMultiConnect);
            // Gestion des multi-connexions si paramètre actif
            if (paramSuccess.isNotMultiConnect) {

              // On récupère les valeurs issues du localStorage
              var tokenName = this.model.getTokenName(); // "fm-data-api"
              var localTokenJs = localStorage.getItem(tokenName) || undefined;
              var localToken = JSON.parse(localTokenJs);
              var localTokenFM = localToken.token;
              var localTokenID = localToken.tokenID;
              // console.log('localTokenFM',localTokenFM);
              // console.log('localTokenID',localTokenID);
  
              var savedTokenFM = userSuccess.tokenFM;
              var savedTokenID = userSuccess.tokenID;
              // console.log('savedTokenFM',savedTokenFM);
              // console.log('savedTokenID',savedTokenID);
  
              // On vérifie qu'il n'y a qu'une seule connexion
              var isTokenFM = 1;
              var isTokenID = 1;
              if (savedTokenFM) isTokenFM = Boolean(localTokenFM && (localTokenFM === savedTokenFM));
              if (savedTokenID) isTokenID = Boolean(localTokenID && (localTokenID === savedTokenID));
  
              if (!isTokenFM || !isTokenID) return false;
  
              // On sauvegarde le recordID de l'utilisateur dans le localStorage
              localStorage.setItem("user-rec-id", userSuccess.recordId);
              // console.log('user-rec-id',localStorage.getItem("user-rec-id"));
  
              // On sauvegarde les Tokens dans la base table APR
              this.model.setUserTokens(userSuccess,localTokenFM,localTokenID);
              var oTokens = {'tokenFM':localTokenFM,'tokenID':localTokenID};
              var sTokens = JSON.stringify(oTokens);
              this.$store.commit('setTokens', sTokens);
            
            } // isNotMultiConnect

            // On mémorise les données dans la couche $store
            this.$store.commit('setUser', userSuccess);
            this.$store.commit('setModel', this.model);
            this.$store.commit('setParam', paramSuccess)
            f_setBaseNameUrl_v(this.constants.project.database);

            // On se rend sur la liste des leçons
            this.$router.push({name: 'assignments'});

          })
          .catch((paramError) => {
            console.error('param error : ', paramError)
            this.errorMsg = paramError.messages[0].message;
          })
        })
        .catch((userError) => {
          console.error('user error : ', userError)
          this.errorMsg = userError.messages[0].message;
        })
      })
      .catch((loginError) => {
        if (loginError.messages[0].code==212 || loginError.messages[0].code==401) {
          this.errorMsg = this.$t("connect.error");
          // "identifiant et/ou mot de passe invalides";
        } else {
          this.errorMsg = loginError.messages[0].message;
        }
      })
    },
  },
  computed: {
    constants() {
      return constants;
    },
    getUser() {
      return this.$store.state.user;
    },
  },
  mounted: function() {
    this.$refs.rLgn.focus();

    var user = this.$store.state.user;
    this.infoMsg = '';
    this.errorMsg = this.$store.state.errorMsg;
    // if (this.$store.state.model) {
    //   this.$store.state.model.logout()
    // }
    try {
      // console.log('🛑🛑🛑-logout-Connect.vue');
      this.$store.state.model.logout(0,user);
      this.$store.commit('setModel', null);
      this.$store.commit('setAssignments', {});
    } catch (e) {
    }
    if (this.$route.params.login) {
      this.user.login = this.$route.params.login;
      this.user.password = this.$route.params.pw;
      this.submit();
    }
  },
}
</script>

<style scoped>
  input.form-control::placeholder {
    color:#bbb;
  }
  div.alert {
    font-size: 1.2rem;
    margin-top: 1rem;
    margin-bottom: 0;
  }
  .loader {
    width: 48px;
    height: 48px;
    display: inline-block;
    position: relative;
    border: 3px solid;
    border-color:#de3500 #0000 #fff #0000;
    border-radius: 50%;
    box-sizing: border-box;
    animation: 1s rotate linear infinite;
  }
 .loader:before , .loader:after{
    content: '';
    top: 0;
    left: 0;
    position: absolute;
    border: 10px solid transparent;
    border-bottom-color:#fff;
    transform: translate(-10px, 19px) rotate(-35deg);
  }
 .loader:after {
    border-color: #de3500 #0000 #0000 #0000 ;
    transform: translate(32px, 3px) rotate(-35deg);
  }
   @keyframes rotate {
    100%{    transform: rotate(360deg)}
  }
  .loader {
    transform: scale(50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/Connect.vue